import React from "react"
import { FormattedMessage } from "react-intl"

export function NewActionBody({ data }) {
  const { source, priority, actor, comment, action, timestamp } = data

  const formValues = [
    {
      id: "general.reactor",
      value: Array.isArray(source) ? source.join(", ") : source,
      description: "Reactor",
    },
    {
      id: "general.priority",
      value: priority,
      description: "Priority",
    },
    {
      id: "general.actor",
      value: actor,
      description: "Actor",
    },
    {
      id: "general.action",
      value: action,
      description: "Action",
    },
    {
      id: "general.comment",
      value: comment,
      description: "Comment",
    },
    {
      id: "general.time",
      value: timestamp,
      description: "Timestamp",
    },
  ]

  return (
    <>
      <div>
        <h4 className={"text-center bottomMarginSpace"}>
          <span className={`fa fa-pencil`} style={{ marginRight: "3px" }} />
          <FormattedMessage
            id={"operatoraction.journal.header"}
            description={"Header For User Input Journal"}
          />
        </h4>
      </div>
      {formValues.map((item, idx) => (
        <div style={{ display: "flex", alignItems: "center" }} key={`item${idx}`}>
          <b>
            <p style={{ margin: "0" }}>
              <FormattedMessage
                id={`${item["id"]}`}
                description={`${item["description"]} Action Confirmation Label`}
              />
            </p>
          </b>
          <p style={{ margin: "0px" }}>{`: ${item["value"]}`}</p>
        </div>
      ))}
    </>
  )
}
